import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Button } from '../shared/Button';
import { ArrowLeftIcon } from 'lucide-react';
export const OnboardingPage = () => {
  return <div className="w-full min-h-screen bg-gradient-to-b from-[#231232] to-[#1a0d24] flex flex-col" data-id="element-43">
      <Helmet data-id="element-44">
        <title data-id="element-45">Schedule Your Onboarding Session</title>
        <meta name="description" content="Schedule your onboarding session with our team" data-id="element-46" />
      </Helmet>
      {/* Header */}
      <header className="w-full py-6 px-4 sm:px-6 lg:px-8 border-b border-[#6805DA]/20" data-id="element-47">
        <div className="max-w-7xl mx-auto flex justify-between items-center" data-id="element-48">
          <Button variant="ghost" href="/" className="text-white/80 hover:text-white flex items-center gap-2" data-id="element-49">
            <ArrowLeftIcon size={18} data-id="element-50" />
            <span data-id="element-51">Back to Home</span>
          </Button>
        </div>
      </header>
      {/* Main Content */}
      <main className="flex-1 py-12 px-4 sm:px-6 lg:px-8 flex flex-col items-center" data-id="element-52">
        <div className="max-w-4xl w-full mx-auto text-center mb-10" data-id="element-53">
          <h1 className="text-3xl sm:text-4xl font-outfit font-bold mb-6 text-white" data-id="element-54">
            Schedule Your Onboarding Session
          </h1>
          <div className="h-1 w-24 bg-gradient-to-r from-[#FFC501] to-[#DF4425] mx-auto rounded-full mb-6" data-id="element-55"></div>
          <p className="text-lg text-white/80 max-w-2xl mx-auto" data-id="element-56">
            Select a time that works best for you to meet with our team and
            begin your career transformation journey.
          </p>
          
        </div>
        {/* Zoom Scheduler Embed */}
        <div className="w-full max-w-4xl bg-white/5 backdrop-blur-sm p-6 sm:p-8 rounded-2xl shadow-xl border border-white/10" data-id="element-57">
          <div className="w-full max-w-[750px] h-[560px] mx-auto overflow-hidden rounded-xl" data-id="element-58">
            <iframe src="https://scheduler.zoom.us/beatrice-bock/onboarding?embedStyle=%7B%22buttonColor%22%3A%22%236805da%22%2C%22fontFamily%22%3A%22Verdana%22%7D&origin=platinum.applypass.com&embed=true" frameBorder="0" style={{
            width: '100%',
            height: '560px'
          }} title="Zoom Scheduler" data-id="element-59"></iframe>
          </div>
          <div className="mt-8 text-center" data-id="element-60">
            <p className="text-white/60 text-sm" data-id="element-61">
              Having trouble with scheduling? Contact us at{' '}
              <a href="mailto:support@applypass.com" className="text-[#FFC501] hover:underline" data-id="element-62">
                support@applypass.com
              </a> <br data-id="element-63" />
              or <a target="_blank" href="https://scheduler.zoom.us/beatrice-bock/onboarding" className="text-[#FFC501] hover:underline" data-id="element-64">
              click here if you're on mobile</a>
            </p>
          </div>
        </div>
      </main>
    </div>;
};